import React, { useContext, useEffect, useRef, useState } from "react";
import { Body, Footer, Header, Main, closeAnimation } from "../../NecttosComp/Layout/Layout";
import Button from "../../NecttosComp/Button/Button";
import Input from "../../NecttosComp/Input/Input";
import { getAxiosTokenInstance } from "../../utils/axiosInstance";
import { useQuery } from "react-query";
import { FirebaseContext } from "../../context/FirebaseContext";
import { Table, Tbody, Td, Th, Thead, Tr } from "../../NecttosComp/Table/Table";
import moment from "moment";
import Instruction from "../../Documentation/Instruction";

export const getFieldDropDowns = (data: any) => async () => {
  const instance = await getAxiosTokenInstance();
  try {
    const resp = await instance.get("/college/action/getClubCellDetails", {
      params: { ...data },
    });
    if (resp.data.statusCode === 400) {
      throw new Error(resp.data.message || "API Error");
    } else {
      return resp?.data?.list;
    }
  } catch (error) {
    throw new Error("API Error");
  }
};

interface invoiceManagementProps {
  onClose: () => void;
}

function ClubCellsAccounts({ onClose }: invoiceManagementProps) {
  const [addNew, setAddNew] = useState<any>();
  const [showForm, setShowForm] = useState(false);
  const { collegeId, user } = useContext(FirebaseContext);
  const ref = useRef<any>(null);

  console.log({ user });

  const { data: tableData = [], refetch } = useQuery("getAllAccadamicddddHolidays", getFieldDropDowns({ collegeId }));

  const handleDelete = async (_id: string) => {
    try {
      const instance = await getAxiosTokenInstance();
      instance
        .post("/college/action/postClubCellDetails", { _id, deleteOne: true })
        .then(() => {
          setAddNew({});
          refetch();
        })
        .catch((err: any) => {
          console.error(err);
        });
      closeAnimation();
      setTimeout(() => setShowForm(false), 500);
    } catch (err) {
      throw new Error("API Error");
    }
  };

  const addNewForm = async () => {
    try {
      const instance = await getAxiosTokenInstance();
      instance
        .post("/college/action/postClubCellDetails", { ...addNew, collegeId, userId: user?.uid })
        .then(() => {
          setAddNew({});
          refetch();
        })
        .catch((err: any) => {
          console.error(err);
        });
      closeAnimation();
      setTimeout(() => setShowForm(false), 500);
    } catch (err) {
      throw new Error("API Error");
    }
  };

  return (
    <>
      <Main title="Body / Club / Cells Accounts" width="90vw" height="90vh">
        <Header>
          <Button
  type="save"
  onClick={() => {
    setAddNew({}); // ✅ Clear previous data
    setShowForm(true);
  }}
>
  Add New
</Button>

          <div className="flex">
            <Button type="print" tableRef={ref.current}>
              Print
            </Button>
            <Button type="excel" tableRef={ref.current}>
              Excel
            </Button>
            <Instruction keyId={'clubCellsAccounts'}/>
            <Button type="close" onClick={onClose}>
              Close
            </Button>
          </div>
        </Header>
        <Body>
          <div ref={ref} className="h-[75vh] pt-2 printable overflow-auto">
            <Table width="100%" innerWidth={["5%", "10%", "35%", "15%", "10%", "10%", "15%"]}>
              <Thead>
                <Tr>
                  <Th position={0}>Sl.No.</Th>
                  <Th position={1}>Short Name</Th>
                  <Th position={2}>Name</Th>
                  <Th position={3}>Type</Th>
                  <Th position={4}>Created By</Th>
                  <Th position={5}>Created On</Th>
                  <Th position={6}>Action</Th>
                </Tr>
              </Thead>
              <Tbody height="auto">
                {tableData?.map((x: any, i: number) => (
                  <Tr>
                    <Td index={i} position={0}>
                      {i + 1}
                    </Td>
                    <Td index={i} position={1}>
                      {x.shortName}
                    </Td>
                    <Td index={i} position={2}>
                      {x.name}
                    </Td>
                    <Td index={i} position={3}>
                      {x.type}
                    </Td>
                    <Td index={i} position={4}>
                      {x?.createdBy}
                    </Td>
                    <Td index={i} position={5}>
                      {x?.createdOn}
                    </Td>
                    <Td index={i} position={6}>
                      <div className="flex print:hidden">
                        <Button
                          type="update"
                          onClick={() => {
                            setAddNew(x);
                            setShowForm(true);
                          }}
                        >
                          Edit
                        </Button>
                        <Button type="delete" onClick={() => handleDelete(x?._id)}>
                          Delete
                        </Button>
                      </div>
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </div>
        </Body>
        <Footer></Footer>
      </Main>

      {showForm && (
        <Main title={addNew && addNew._id ? 'Edit' : 'Add New'} width="40vw" height="40vh">
          <Header>
           
          </Header>
          <Body>
            <div className="flex flex-col w-full">
              <Input width="100%" fieldName="Short Name" returnKey="shortName" state={addNew} setState={setAddNew} type="text" />
              <Input width="100%" fieldName="Name" returnKey="name" state={addNew} setState={setAddNew} type="text" />
              <Input width="100%" fieldName="Type" returnKey="type" state={addNew} setState={setAddNew} options={["Body", "Club", "Cell"]} type="drop" />
              <div className="flex justify-center">
              <Button
              type="close"
              onClick={() => {
                closeAnimation();
                setTimeout(() => setShowForm(false), 500);
              }}
            >
              Cancel
            </Button>
              <Button
                type="save"
                onClick={() => {
                  addNewForm();
                }}
              >
                 {addNew && addNew._id ? 'Update' : 'Save'} 
              </Button></div>
            </div>
          </Body>
        </Main>
      )}
    </>
  );
}

export default ClubCellsAccounts;
